<template>
  <div class="font-display uppercase">
    <span>{{ text }}</span>
    <span class="stroked">{{ text }}</span>
    <span class="hidden md:inline">{{ text }}</span>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    text: {
      type: String,
      default: "text",
    },
  },
  setup() {
    return {};
  },
});
</script>
<style scoped>
.stroked {
  color: black;
  -webkit-text-fill-color: white; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;
}
</style>
